import { AdditionalColumnCellProps } from "PFApp/activities/manage_roles/parts/additional_column_cell/additional_column_cell.types";
import { ManageRolesMultiForm } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Stack } from "PFComponents/containers";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { ActivityState } from "PFCore/types";
import { useWatch } from "react-hook-form";

import css from "../cell.module.scss";

export const StateAdditionalColumnCell = ({ rolesFormKey, info }: AdditionalColumnCellProps) => {
  const name = `${rolesFormKey}.${info.row.index}.state` as const;
  const state = useWatch<ManageRolesMultiForm>({ name }) as ActivityState | undefined;

  return (
    <Stack className={css.cell} qaId="ManageRoles.RoleRow.StateCell">
      <RoleStatusBadge state={state} />
    </Stack>
  );
};
